import { Model, belongsTo } from 'miragejs'

export default Model.extend({
  // the ember data SchoolRollover has a rolloverOwner belongsTo() RolloverOwner
  // however here the mirage SchoolRollover reflects the BE payload
  // where the SchoolRollover belongs to a Teacher
  user: belongsTo('teacher'),
  school: belongsTo(),
})
